import { number, object } from 'yup';

export const validationSchema = object().shape({
  chanceToWin: number().min(0).max(100),
});
